export interface OrganizationScopeInput {
  organizationId?: string | null;
  tenantId?: string | null;
  sessionTenantId?: string | null;
}

export function normalizeOrganizationId(
  value?: string | null,
): string | undefined {
  if (typeof value !== "string") {
    return undefined;
  }
  const trimmed = value.trim();
  if (!trimmed || trimmed === "__global__") {
    return undefined;
  }
  return trimmed;
}

export function resolveOrganizationId(
  input: OrganizationScopeInput,
): string | undefined {
  return (
    normalizeOrganizationId(input.organizationId) ??
    normalizeOrganizationId(input.tenantId) ??
    normalizeOrganizationId(input.sessionTenantId)
  );
}

export function resolveOrganizationScope(
  input: OrganizationScopeInput,
): { organizationId?: string; tenantId?: string } {
  const organizationId = resolveOrganizationId(input);
  return organizationId
    ? { organizationId, tenantId: organizationId }
    : {};
}
